import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

/**
 * Extracts the domain name from a URL
 * @param {string} url - The full URL
 * @returns {string} The extracted domain name without protocol and www
 * @example
 * extractDomainName("https://www.amazon.com/product") // returns "amazon"
 * extractDomainName("http://shop.example.co.uk/item") // returns "shop.example"
 */
export function extractDomainName(url) {
    if (!url || typeof url !== 'string') {
        return '';
    }

    try {
        // Remove protocol and www, extract domain
        return url.replace(/^(?:https?:\/\/)?(?:www\.)?([^\/\s]+)\..*$/, "$1");
    } catch (error) {
        console.error('Error extracting domain name:', error);
        return url;
    }
}
